// ProcessSteps.jsx
import React, { useState } from "react";
import "../style/ProcessSteps.scss";

const steps = [
  {
    id: 1,
    title: "01 - Research",
    items: [
      {
        heading: "Discovery",
        description:
          "We start by diving deep into your brand's identity, goals, and target audience. This phase helps set a strong foundation for the entire project, ensuring alignment with your vision and business objectives.",
      },
      {
        heading: "UX Research",
        description:
          "User experience is key to success. We analyze user behavior, conduct usability studies, and gather insights to create a seamless and intuitive experience, boosting engagement and satisfaction.",
      },
      {
        heading: "Competition Analysis",
        description:
          "We study the competition to uncover gaps and opportunities. Understanding competitors’ strengths and weaknesses allows us to create a standout project, offering unique value propositions and innovative solutions.",
      },
    ],
  },
  {
    id: 2,
    title: "02 - Design",
    items: [
      {
        heading: "Wireframes",
        description:
          "We start with wireframes to map out the website structure and functionality before diving into the design phase, ensuring clear and effective layouts.",
      },
      {
        heading: "UI Design",
        description:
          "We design visually striking, user-friendly interfaces that align with your brand and appeal to your target audience, creating a seamless experience across all devices.",
      },
    ],
  },
  {
    id: 3,
    title: "03 - Development",
    items: [
      {
        heading: "Frontend & Backend",
        description:
          "We build dynamic, responsive websites with modern technologies, ensuring functionality and performance across platforms, all tailored to your business needs.",
      },
    ],
  },
  {
    id: 4,
    title: "04 - Optimization",
    items: [
      {
        heading: "Performance & SEO",
        description:
          "We fine-tune the performance of your site, ensuring fast load times, strong SEO practices, and compliance with accessibility standards to reach a wider audience.",
      },
    ],
  },
];

const ProcessSteps = () => {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <section className="process-steps">
        <div className="site-heading-ProcessSteps">
          <h2>Our <span>Process</span></h2>
          <h4>At <span>EVAS</span>, we follow a structured approach to create visually compelling websites that deliver exceptional user experiences and drive results.</h4>
        </div>
      <div className="tabs-steps">
        {steps.map((step, index) => (
          <button
            key={index}
            className={index === activeStep ? "active" : ""}
            onClick={() => setActiveStep(index)}
          >
            {step.title}
          </button>
        ))}
      </div>

      <div className="content-ProcessSteps">
        {steps[activeStep].items.map((item, index) => (
          <div className="row-ProcessSteps" key={index}>
            <div className="heading">{item.heading}</div>
            <div className="description">{item.description}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProcessSteps;
